import { RunbookSection, RunbookStep, RunbookTask } from 'data/schemas/MigrationRunbook';

const clientId = (prefix: string) =>
    `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export function createTask(sequence: number): RunbookTask {
    return {
        id: clientId('task'),
        title: '',
        detail: '',
        sequence,
        plannedMinutes: 0,
        isRequired: true,
        assigneeCitizenId: '',
        assigneeName: '',
        status: 'not_started',
        remark: '',
        blockerReason: '',
        versionNo: 1
    };
}

export function createStep(sequence: number): RunbookStep {
    return {
        id: clientId('step'),
        title: `Step ${sequence}`,
        description: '',
        sequence,
        plannedMinutes: 0,
        isRequired: true,
        defaultAssigneeCitizenId: '',
        defaultAssigneeName: '',
        tasks: [createTask(1)]
    };
}

export function createDefaultSections(): RunbookSection[] {
    return [
        {
            id: clientId('section'),
            sectionType: 'execution',
            title: 'Main Execution',
            sequence: 1,
            steps: [createStep(1)]
        },
        {
            id: clientId('section'),
            sectionType: 'rollback',
            title: 'Rollback',
            sequence: 2,
            steps: []
        }
    ];
}

export function resequenceSteps(steps: RunbookStep[]) {
    return steps.map((step, index) => ({
        ...step,
        sequence: index + 1,
        tasks: step.tasks.map((task, taskIndex) => ({ ...task, sequence: taskIndex + 1 }))
    }));
}

export function moveItem<T>(items: T[], from: number, to: number) {
    if (to < 0 || to >= items.length) {
        return items;
    }

    const next = [...items];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    return next;
}
